module.exports = __webpack_public_path__ + "h5/img/hb1-1.2dce9c38.png";